/* eslint-disable @typescript-eslint/no-explicit-any*/
import React, { useState } from "react";
import { apolloClient } from "../../providers/Apollo";
import { Auth } from "aws-amplify";
import { ReactComponent as ChevronUp } from "../../assets/icons/chevron_up.svg";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../providers/Notification";
import Box from "@mui/material/Box";
import StyledButton from "./StyledButton";
import ListItem from "@mui/material/ListItem";
import Stack from "@mui/material/Stack";
import DeleteAccountModal from "../DeleteAccountModal";
import settings from '../../assets/icons/inactive/Settings.svg';

interface Props {
  onNavigate?: () => void;
}

const Settings = ({ onNavigate }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const notify = useNotifications();

  const settingsOptions = [
    { menuItem: "Personal information", icon: "" },
    { menuItem: "About myNILpay", icon: "" },
    { menuItem: "Contact support", icon: "" },
    { menuItem: "Legal/Privacy", icon: "" },
    { menuItem: "Logout", icon: "" },
    { menuItem: "Delete account", icon: "" },
  ];

  async function logout() {
    localStorage.setItem("setClearData", "clearData")
    try {
      await Auth.signOut();
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("LoginUserObject");
      apolloClient.cache.reset();
      return navigate("/login", { replace: true });
    } catch (error) {
      notify.error("error signing out");
      // console.log("error signing out: ", error);
    }
  }
  const isSelected = (page: string) => {
    if (page === "Legal/Privacy") {
      page = "privacy"
    }
    const path = location.pathname;
    const first = path?.split("/")[1];
    const navUrl = first.toLocaleLowerCase();
    const selected = page.toLocaleLowerCase().split(' ').join('');
    return selected === navUrl;
  };
  const handleClick = (page: string) => {

    switch (page) {
      case "Personal information":
        // Close side nav on mobile
        if (onNavigate) onNavigate();
        navigate("/personalinformation");
        break;
      case "Legal/Privacy": navigate('/privacy')
        break
      case "Logout":
        logout();
        break;
      case "Delete account":
        setOpenModal(true);
        break;
      case "Contact support":
        navigate("/contactsupport");
        // window.open(SUPPORTLINK_URL, "_blank");
        break;
      case "About myNILpay":
        navigate("/aboutmynilpay");
        // window.open(SUPPORTLINK_URL, "_blank");
        break;

      default:
        // NOTE: Privacy, FAQs, and About links where not provided by myNILpay
        // so we are redirecting to their website instead
        window.open("https://www.mynilpay.com/", "_blank");
        break;
    }
  };


  return (
    <>
      <DeleteAccountModal open={openModal} setOpen={setOpenModal} />
      <ListItem disablePadding>
        <StyledButton page={{ icon: settings, menuItem: "Account settings", isactive: true }} onClick={() => setShow(!show)}>
          <Box
            sx={{
              transition: "transform 300ms",
              transform: show ? "rotate(0deg)" : "rotate(180deg)",
            }}
          > <ChevronUp />
          </Box>
        </StyledButton>
      </ListItem>
      {show && (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <Stack sx={{ marginLeft: 2 }} spacing={1}>
          {/* eslint-disable-next-line */}
          {settingsOptions.map((name: any) => (
            <StyledButton
              key={name.menuItem}
              page={name}
              onClick={() => handleClick(name.menuItem)}
              isSelected={isSelected(name.menuItem)}
            />
          ))}
        </Stack>
      )}
    </>
  );
};

export default Settings;
